import { render, staticRenderFns } from "./OutstandingCreditListView.vue?vue&type=template&id=e1840104&scoped=true"
import script from "./OutstandingCreditListView.vue?vue&type=script&lang=js"
export * from "./OutstandingCreditListView.vue?vue&type=script&lang=js"
import style0 from "./OutstandingCreditListView.vue?vue&type=style&index=0&id=e1840104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1840104",
  null
  
)

export default component.exports